// extracted by mini-css-extract-plugin
export const partners = "partners-module--partners--2aHyJ";
export const partnersHeader = "partners-module--partnersHeader--3jnU-";
export const partnerImages = "partners-module--partnerImages--16dV0";
export const partnerImage = "partners-module--partnerImage--1jK_i";
export const nbaImage = "partners-module--nbaImage--1G0ej";